import PropTypes from 'prop-types';

export const AdvanceNavMenuFontWeight = {
  light: '',
  lighter: 'lighter',
  bold: 'bold',
  bolder: 'bolder',
  boldest: 'boldest',
};

export const AdvanceNavMenuColor = {
  primary: 'primary',
  secondary: 'secondary',
  success: 'success',
  warning: 'warning',
  danger: 'danger',
  info: 'info',
  dark: 'dark',
  light: 'light',
};

AdvanceNavMenu.propTypes = {
  itemList: PropTypes.arrayOf(
    PropTypes.shape({
      iconElement: PropTypes.element,
      text: PropTypes.string,
      active: PropTypes.bool,
      disabled: PropTypes.bool,
      labelElement: PropTypes.element,
      showArrow: PropTypes.bool,
      showBullet: PropTypes.bool,
      onClick: PropTypes.func,
    })
  ),
  fontWeight: PropTypes.oneOf(Object.values(AdvanceNavMenuFontWeight)),
  enableHoverStyle: PropTypes.bool,
  enableActiveStyle: PropTypes.bool,
  enableLinkRounded: PropTypes.bool,
  enableAccentStyle: PropTypes.bool,
  color: PropTypes.oneOf(Object.values(AdvanceNavMenuColor)),
};

function AdvanceNavMenu({
  itemList = [],
  fontWeight = AdvanceNavMenuFontWeight.light,
  enableHoverStyle = false,
  enableActiveStyle = false,
  enableLinkRounded = false,
  enableAccentStyle = false,
  color = AdvanceNavMenuColor.primary,
}) {
  return (
    <div>
      <ul
        className={`navi navi-${fontWeight} ${enableHoverStyle ? 'navi-hover' : ''} ${
          enableActiveStyle ? 'navi-active' : ''
        } ${enableAccentStyle ? 'navi-accent' : ''} ${
          enableLinkRounded ? 'navi-link-rounded' : ''
        } navi-${color}`}
      >
        {itemList.map((item, index) => {
          return (
            <li className="navi-item" key={index}>
              <a
                className={`navi-link ${item.active ? 'active' : ''} ${
                  item.disabled ? 'disabled' : ''
                }`}
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  if (item.disabled) return;
                  if (item.onClick) {
                    item.onClick();
                  }
                }}
              >
                {item.showBullet && (
                  <span className="navi-bullet">
                    <i className="bullet" />
                  </span>
                )}
                {item.iconElement && <span className="navi-icon">{item.iconElement}</span>}
                <span className="navi-text">{item.text}</span>
                {item.labelElement && <span className="navi-label">{item.labelElement}</span>}
                {item.showArrow && <span className="navi-arrow"></span>}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default AdvanceNavMenu;
